<template>
  <div class="page_panel">
    <!--
    <div style="width: 100%; background: rgba(255, 0, 0, 0.2); position: fixed; height: 100%; z-index: 100; backdrop-filter: blur(5px); top: 0px; font-size: 36px; display: flex; padding: 40px; color: #ffeb00">
      <div style="flex: 1">
        <div style="font-size: 2em;">已于 2025/05/06 11:00 暂停</div>
        <div>转做农机云APP的「增加AI入口」功能</div>
        <div>进度：排版中。下一步开始做中间的地区功能</div>
      </div>
    </div>
    -->
    <VehicleModelsSelecter
      v-model="currentVehicleModelCode"
      :list="vehicleModels"
      :closeWhenSelected="true"
      class="vehicle-models-selecter"
    />
    <div class="left_panel" :class="getLeftFold ? '' : 'collected'">
      <div class="l_top">
        <div class="l_t_item">
          <img class="l_t_item_icon" :src="statisticIcon.total" alt="ICON" />
          <div class="l_t_item_title">监控总量（台）</div>
          <div class="l_t_item_num">
            {{ statistic.total | numberSeparator }}
          </div>
        </div>
        <div class="l_t_item">
          <img class="l_t_item_icon" :src="statisticIcon.online" alt="ICON" />
          <div class="l_t_item_title">在线数量</div>
          <div class="l_t_item_num">
            {{ statistic.online | numberSeparator }}
          </div>
        </div>
      </div>
      <div class="l_center">
        <Block title="农情风险多维度AI预警">
          <div
            @mouseover="stopWeatherCategorySides"
            @mouseleave="runWeatherCategorySides"
          >
            <ul class="categories">
              <li
                :class="{
                  selected: currentWarningCategoryIndex === i,
                  disabled: !isCropWork && i > 0,
                }"
                @click="switch2warningCategory(i)"
                v-for="(item, i) in warningCategories"
                :key="`warningCategories.${item.label}`"
                :title="`${
                  i == 0
                    ? ''
                    : isCropWork
                    ? ''
                    : `农机品类不是「收获类机械」时不可查看${
                        item.label || '此项'
                      }`
                }`"
              >
                <div class="icon"></div>
                <div class="label">{{ item.label || `预警${i + 1}` }}</div>
                <template v-if="i == 0">
                  <div class="value">{{ item.value | numberSeparator }}</div>
                </template>
                <template v-else>
                  <div class="value" v-if="isCropWork">
                    {{ item.value | numberSeparator }}
                  </div>
                  <div class="value" v-else>--</div>
                </template>
              </li>
            </ul>
            <div class="tip" v-if="currentWarningCategoryIndex == 0">
              (预警信息来源：国家预警信息发布中心)
            </div>
            <ul
              class="warnings"
              :class="{
                'no-scrollable': currentWarning.length < 3,
                'is-weather': currentWarningCategoryIndex == 0,
              }"
            >
              <li class="empty" v-if="!currentWarning.length">
                暂无{{
                  (warningCategories[currentWarningCategoryIndex] &&
                    warningCategories[currentWarningCategoryIndex].label) ||
                  ""
                }}数据
              </li>
              <template v-else>
                <li
                  @click="showWarningDetail(item)"
                  v-for="(item, index) in currentWarning"
                  :key="index"
                >
                  <div class="icon">
                    <img :src="getIcon(item)" />
                  </div>
                  <div class="title">{{ item.title || "无标题预警" }}</div>
                </li>
              </template>
            </ul>
          </div>
        </Block>
      </div>
      <div class="l_bottom">
        <Block title="AI智能机手调度">
          <div
            class="nothing"
            v-if="!driverDispatches || !driverDispatches.length"
          >
            <div>空</div>
          </div>
          <div class="box" v-autoside v-else>
            <div class="siders">
              <div
                class="side"
                v-for="(v, index) in driverDispatches"
                :key="`driverDispatches.${index}`"
              >
                <div class="question">
                  <div class="card">
                    <div data-category="需求咨询" class="icon">
                      <img :src="defaultWorkImg" />
                    </div>
                    <div class="attr">
                      <div class="title">
                        <div class="name">
                          {{ v.farmInfo.jobTypeName ?? "作业类型不详" }}
                        </div>
                        <div class="tag">
                          {{
                            v.farmInfo.estimateWorkload ?? "预估工作量不详"
                          }}亩
                        </div>
                      </div>
                      <div class="date" title="作业起止日期">
                        {{ v.farmInfo.jobStartTime ?? "--" }} -
                        {{ v.farmInfo.jobEndTime ?? "--" }}
                      </div>
                      <div class="contact">
                        <div class="user">
                          <span :title="v.farmInfo.realName">{{
                            v.farmInfo.nickname ?? "--"
                          }}</span>
                        </div>
                        <div class="phone">
                          <span>{{ v.farmInfo.phone ?? "--" }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="address">{{ v.farmInfo.address ?? "--" }}</div>
                  <div class="reason">{{ v.farmInfo.description ?? "--" }}</div>
                </div>
                <div class="answer">
                  <div class="title">AI回复</div>
                  <div class="content" v-scroll>
                    {{
                      `根据您的位置（${v.farmInfo.address || ""}）和作业需求（${
                        v.farmInfo.estimateWorkload ?? "预估工作量不详"
                      }亩${
                        v.farmInfo.jobTypeName ?? "作业类型不详"
                      }），结合农机定位、机型匹配度、作业半径和用户评价，为您推荐以下机手和合作社：`
                    }}
                  </div>
                </div>
                <ul class="recommends">
                  <li
                    class="empty"
                    v-if="!v.cooperatives.length && !v.cooperatives.length"
                  >
                    暂无推荐机手或合作社
                  </li>
                  <li
                    class="cooperative"
                    v-for="(d, ci) in v.cooperatives"
                    :key="`cooperatives.${index}.${ci}`"
                  >
                    <div class="company">{{ d.company ?? "无名合作社" }}</div>
                    <div class="user">
                      <div class="name">
                        <span :title="d.name">{{ d.nickname ?? "--" }}</span>
                      </div>
                      <div
                        :data-phone="d.phone"
                        :data-faker="d.maskedPhone"
                        class="phone"
                      ></div>
                    </div>
                    <div class="attrs">
                      <div class="item-group" v-if="false">
                        <div data-label="品目" class="item" :title="d.model">
                          <span>{{ d.model ?? "--" }}</span>
                        </div>
                        <div
                          data-label="数量"
                          data-unit="台"
                          class="item no-wrap"
                        >
                          <span>{{ d.total ?? "--" }}</span>
                        </div>
                      </div>
                      <div
                        data-label="位置"
                        class="item address"
                        :title="`${d.address || ''}（距离作业地点约${
                          d.distance
                        }米）`"
                      >
                        <span>{{ d.address ?? "--" }}</span>
                        <span class="tail"
                          >距离作业地点约{{ d.distance | distance }}公里</span
                        >
                      </div>
                      <div data-label="优势" class="item" :title="d.advantage">
                        <span>{{ d.advantage ?? "--" }}</span>
                      </div>
                    </div>
                  </li>
                  <li
                    class="driver"
                    v-for="(d, di) in v.drivers"
                    :key="`drivers.${index}.${di}`"
                  >
                    <div class="user">
                      <div class="name">
                        <span :title="d.name">{{ d.nickname ?? "--" }}</span>
                      </div>
                      <div
                        :data-phone="d.phone"
                        :data-faker="d.maskedPhone"
                        class="phone"
                      ></div>
                    </div>
                    <div class="attrs">
                      <div data-label="机型" class="item" :title="d.model">
                        <span>{{ d.model ?? "--" }}</span>
                      </div>
                      <div
                        data-label="位置"
                        class="item address"
                        :title="d.address"
                      >
                        <span>{{ d.address ?? "--" }}</span>
                        <span class="tail"
                          >距离作业地点约{{ d.distance | distance }}公里</span
                        >
                      </div>
                      <div data-label="优势" class="item" :title="d.advantage">
                        <span>{{ d.advantage ?? "--" }}</span>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </Block>
      </div>
    </div>
    <div class="map_container">
      <Map
        :vehicleModel="currentVehicleModelCode"
        :dragable="false"
        @warning="showWarningDetail"
        ref="map"
      />
    </div>
    <div class="right_panel" :class="getRightFold ? '' : 'collected'">
      <div class="r_top">
        <div
          class="r_t_item"
          :class="{ disabled: !isCropWork }"
          :title="
            isCropWork
              ? ''
              : '农机品类不是「收获类机械」时不可查看全县总体作业进度'
          "
        >
          <img class="r_t_item_icon" :src="statisticIcon.progress" alt="ICON" />
          <div class="r_t_item_title">全县总体作业进度</div>
          <div class="r_t_item_num">
            <template v-if="isCropWork"
              >{{ statistic.progress ?? "--" }}%</template
            >
            <template v-else>--</template>
          </div>
        </div>
      </div>
      <div class="r_center">
        <Block :title="`全县${REASON[season] || '季度'}机收完成进度`">
          <RightFirst
            :progresses="seasonProgresses"
            :interval="INTERVAL.全县季度机收完成进度.value"
          />
        </Block>
      </div>
      <div class="r_bottom">
        <Block :title="`${REASON[season] || '季度'}收割热力情况`">
          <table>
            <thead>
              <tr>
                <th>区域</th>
                <th>预估收割机数量(台)</th>
                <th>热力度</th>
                <th title="共「优、良、中、低」四个等级">
                  收割能力<br />等级评估
                </th>
              </tr>
            </thead>
          </table>
          <div v-vscroll class="siders">
            <table>
              <tbody>
                <tr
                  class="empty"
                  v-if="!harvestingProgress || !harvestingProgress.length"
                >
                  <td colspan="4">
                    <div>空</div>
                  </td>
                </tr>
                <!-- 注意：总条数需要偶数，否则隔行变色首尾相接时会同色。奇数时可复制一份列表 -->
                <tr
                  v-for="(v, i) in harvestingProgress"
                  :key="i"
                  :class="{ [`index_${i}`]: v, even: i % 2 }"
                >
                  <td>{{ v.areaName ?? "--" }}</td>
                  <td>{{ v.vehicleCount ?? "--" }}</td>
                  <td>{{ v.heat ?? "--" }}%</td>
                  <td>{{ v.levelName ?? "--" }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </Block>
      </div>
    </div>
    <!-- sideControl: 控制左侧和右侧的收起和展开 -->
    <div class="sideControl">
      <div
        class="item left"
        :title="getLeftFold ? '收起左侧' : '展开左侧'"
        :class="{ collected: !getLeftFold }"
        @click="$store.dispatch('setLeftFold', !getLeftFold)"
      ></div>
      <div
        class="item right"
        :title="getRightFold ? '收起右侧' : '展开右侧'"
        :class="{ collected: !getRightFold }"
        @click="$store.dispatch('setRightFold', !getRightFold)"
      ></div>
    </div>
    <WeatherDialog ref="weatherDialog" @close="runWeatherCategorySides()" />
    <ThermodynamicDialog
      ref="thermodynamicDialog"
      @close="runWeatherCategorySides()"
    />
  </div>
</template>

<script>
import { GetWarningIcon, REASON, DV_VEHICLE_MODEL_CODES } from "./constants";
import RightFirst from "./RightFirst.vue";
import Block from "@components/block";
import { mapGetters } from "vuex";
import Map from "./Map.vue";
import VehicleModelsSelecter from "./components/vehicleModelsSelecter.vue";
import WeatherDialog from "./dialogs/weather.vue";
import ThermodynamicDialog from "./dialogs/thermodynamic.vue";
// prettier-ignore
import { 
  seasonProgress as SeasonProgressDataApi, 
  harvestingProgress as HarvestingProgressDataApi, 
  statistic as StatisticDataApi, 
  warningCategories as WarningCategoriesApi,
  driverDispatch as DriverDispatchApi,
} from './api';

// 滚动间隔（毫秒）{value:间隔时间,min:滚动需要最小记录数}
const INTERVAL = {
  农情风险多维度AI预警: { value: 10000, min: 1 },
  AI智能机手调度: { value: 10000, min: 1 },
  全县季度机收完成进度: { value: 3000, min: 1 },
  季度收割热力情况: { value: 3000, min: 9 }, // value 不能小于 1100
};
// 农机品类 0全部 1收获类机械 2播种类机械 3插秧类机械 4耕整类机械 5植保类机械 6收获后处理机械 7其他机械
const VEHICLE_MODEL = [
  "全部",
  "收获类机械",
  "播种类机械",
  "插秧类机械",
  "耕整类机械",
  "植保类机械",
  "收获后处理机械",
  "其他机械",
];
const VEHICLE_ICON_PATH_PREFIX = "/images/dispatch/vehicleCode/{c}{p}.png";

export default {
  components: {
    Block,
    Map,
    RightFirst,
    VehicleModelsSelecter,
    WeatherDialog,
    ThermodynamicDialog,
  },
  data() {
    let self = this;
    return {
      // 统计数值
      statistic: {},
      // 农情风险多维度AI预警
      currentWarningCategoryIndex: 0, // 当前选中预警类型
      warningCategories: [
        {
          label: "气象预警",
          value: "94,367",
          list: [],
        },
        {
          label: "收割进度预警",
          value: "94,367",
          list: [],
        },
        {
          label: "收割热力预警",
          value: "94,367",
          list: [],
        },
      ],
      // 「AI智能机手调度」的默认图片
      defaultWorkImg: require(`./images/pic_zy_mr_s.png`),
      // 「AI智能机手调度」
      driverDispatches: [],
      // 全县季度机收完成进度
      seasonProgresses: [
        // {
        //   areaName: '郑州', // 区域名称
        //   plantingArea: 100, // 已完成作业面积
        //   completedArea: 99.9, // 种植面积
        //   progress: 99.9, // 完成进度
        //   warning: false, // 是否预警
        // },
      ],
      // 三夏收割热力情况、三秋收割热力情况
      harvestingProgress: [],
      // 农机品目
      currentVehicleModelCode: null,
      // 农机品目下拉及选中状态 0全部 1 收获类机械 2 播种类机械 3 插秧类机械 4 耕整类机械 5 植保类机械 6 收获后处理机械 7 其他机械
      vehicleModels: VEHICLE_MODEL.map((label, code) => ({
        label,
        code: "" + code,
        disabled: 0,
        selected: self.$store.getters.getMachineryType == code,
      })),
      // 三个统计值的所有图标
      statisticIcons: [],
      // 各滚动间隔时间配置
      INTERVAL,
      // 季度类型（返回SX三夏 SQ三秋）
      REASON,
    };
  },
  computed: {
    ...mapGetters([
      "season",
      "getLeftFold",
      "getRightFold",
      "getLastAddreassName",
      "getLastPreAddreassName",
      "getactiveRegionObj",
      "getMachineryType",
    ]),
    // 「农情风险多维度AI预警」当前选中预警类型的预警事件列表
    currentWarning() {
      let self = this;
      let list =
        self.warningCategories[self.currentWarningCategoryIndex]?.list || [];
      return list;
    },
    // 可以使用「收割热力图、收割进度图」的农机分类code
    isCropWork() {
      let self = this;
      let is = DV_VEHICLE_MODEL_CODES.includes(self.currentVehicleModelCode);
      return is;
    },
    // 三个统计值的图标（选择不同的「农机品类」时显示不同的图标）
    statisticIcon() {
      let self = this;
      const code = self.currentVehicleModelCode ?? 0;
      const c = ("" + code).padStart(2, "0");
      const reg = new RegExp(`${c}\\d`);
      const imgs = self.statisticIcons.filter((v) => reg.test(v.name));
      const getOneImg = (suffix) => {
        const reg = new RegExp(`\\d{2}${suffix}`);
        const img = imgs.find((v) => reg.test(v.name));
        const src = img && img.src;
        return src;
      };
      const icons = {
        total: getOneImg("1"), // 监控总量（台）
        online: getOneImg("2"), // 在线数量
        progress: getOneImg("3"), // 全县总体作业进度
      };
      // console.log('statisticIcons', icons);
      return icons;
    },
  },
  watch: {
    // $store 中的「农机品类」值
    getMachineryType: {
      handler(v) {
        let self = this;
        self.currentVehicleModelCode = v || 0;
      },
      immediate: true,
    },
    // 「农机品类」改变后同步到 store
    currentVehicleModelCode: {
      handler(v) {
        let self = this;
        self.$store.commit("setMachineryType", v || 0);
        self.getDataOfEachModel();
      },
      immediate: true,
    },
    $route(v) {
      let self = this;
      const path = v.fullPath;
      if (/^\/aiDispatch/.test(path)) {
        // console.log({ leftSideVisible: self.getLeftFold, rightSideVisible: self.getRightFold });
        // 默认展开两侧
        if (!self.getLeftFold) {
          self.$store.dispatch("setLeftFold", true);
        }
        if (!self.getRightFold) {
          self.$store.dispatch("setRightFold", true);
        }
        // 回中心点
        self.$refs.map.goCenterPoint();
      }
    },
  },
  methods: {
    // 统计数值
    getStatistic() {
      let self = this;
      typeof self.getStatistic_cancel === "function" &&
        self.getStatistic_cancel(); // 取消上一个请求以用参数重新获取
      const promise = StatisticDataApi();
      self.getStatistic_cancel = promise.cancel || (() => {});
      promise
        .then((res) => {
          console.log("统计数值.res", res);
          self.statistic = res || {};
          // self.seasonProgresses = (res || []).slice(0, 10);
        })
        .catch((res) => {
          console.log("统计数值.err", res);
          self.statistic = {};
        });
    },
    // 农情风险多维度AI预警（气象、收割进度、收割热力）
    getWarningCategories() {
      let self = this;
      typeof self.getStatistic_cancel === "function" &&
        self.getStatistic_cancel(); // 取消上一个请求以用参数重新获取
      const promise = WarningCategoriesApi();
      self.getStatistic_cancel = promise.cancel || (() => {});
      promise
        .then((res) => {
          console.log(
            "%c农情风险多维度AI预警（气象、收割进度、收割热力）.res",
            "color:#CC0",
            res
          );
          self.warningCategories = res || [];
          if (res.length) {
            self.currentWarningCategoryIndex = 0;
          }
        })
        .catch((res) => {
          console.log(
            "农情风险多维度AI预警（气象、收割进度、收割热力）.err",
            res
          );
          self.warningCategories = [];
        });
    },
    switch2warningCategory(i) {
      let self = this;
      if (i > 0 && !self.isCropWork) {
        return;
      }
      self.currentWarningCategoryIndex = i;
    },
    // 预警详情
    showWarningDetail(item) {
      let self = this;
      const type = item && item.type;
      // 预警类型 { type: '收割热力:thermodynamic,收割进度:progression,天气:weather'}
      switch (type) {
        case "weather":
          self.$refs.weatherDialog.show(item);
          break;
        case "thermodynamic":
        case "progression":
          self.$refs.thermodynamicDialog.show(item);
          break;
        default:
          console.log("showWarningDetail", { type, item });
      }
      // 停止「农情风险多维度AI预警」的定时切换 setTimout 用于防止 mouseleave 事件重新触发滚动启动功能
      setTimeout(() => {
        self.stopWeatherCategorySides();
      });
    },
    // 「AI智能机手调度」
    getDriverDispatches() {
      let self = this;
      typeof self.getDriverDispatches_cancel === "function" &&
        self.getDriverDispatches_cancel(); // 取消上一个请求以用参数重新获取
      const promise = DriverDispatchApi();
      self.getDriverDispatches_cancel = promise.cancel || (() => {});
      promise
        .then((res) => {
          console.log(
            "%cAI智能机手调度.res",
            "color:#CC0",
            JSON.parse(JSON.stringify(res))
          );
          self.driverDispatches = res || [];
        })
        .catch((res) => {
          self.driverDispatches = [];
          console.log("AI智能机手调度.err", res);
        });
    },
    // 全县三夏三秋机收完成进度
    getSeasonProgress() {
      let self = this;
      typeof self.getSeasonProgress_cancel === "function" &&
        self.getSeasonProgress_cancel(); // 取消上一个请求以用参数重新获取
      const promise = SeasonProgressDataApi();
      self.getSeasonProgress_cancel = promise.cancel || (() => {});
      promise
        .then((res) => {
          console.log(
            "%c全县三夏三秋机收完成进度.res",
            "color:#CC0",
            JSON.parse(JSON.stringify(res))
          );
          self.seasonProgresses = res || [];
          // self.seasonProgresses = (res || []).slice(0, 10);
        })
        .catch((res) => {
          console.log("全县三夏三秋机收完成进度.err", res);
          self.seasonProgresses = [];
        });
    },
    // 三夏三秋收割热力情况
    getHarvestingProgress() {
      let self = this;
      typeof self.getHarvestingProgress_cancel === "function" &&
        self.getHarvestingProgress_cancel(); // 取消上一个请求以用参数重新获取
      const promise = HarvestingProgressDataApi();
      self.getHarvestingProgress_cancel = promise.cancel || (() => {});
      promise
        .then((res) => {
          console.log(
            "%c三夏三秋收割热力情况.res",
            "color:#CC0",
            JSON.parse(JSON.stringify(res))
          );
          self.harvestingProgress = res || [];
        })
        .catch((res) => {
          console.log("三夏三秋收割热力情况.err", res);
          self.harvestingProgress = [];
        });
    },
    getIcon(item) {
      const { level, category, type } = item;
      const src = GetWarningIcon(type, level, category);
      return src;
    },
    // 左上角「农情风险多维度AI预警」的定时切换
    runWeatherCategorySides() {
      let self = this;
      let interval = INTERVAL.农情风险多维度AI预警.value;
      if (!self.runWarningCategorySidesHandler) {
        self.runWarningCategorySidesHandler = setInterval(() => {
          // 如果农机品类不是「收获类机械」时，只能查看气象预警，禁止查看另外两个「收割进度预警、收割热力预警」
          if (!self.isCropWork) {
            self.currentWarningCategoryIndex = 0;
            return;
          }
          self.currentWarningCategoryIndex = ((index) => {
            if (
              self.warningCategories.length < INTERVAL.农情风险多维度AI预警.min
            ) {
              return 0;
            }
            let i = index;
            i++;
            if (i > self.warningCategories.length - 1) {
              i = 0;
            }
            return i;
          })(self.currentWarningCategoryIndex);
        }, interval);
      }
    },
    stopWeatherCategorySides() {
      let self = this;
      if (self.runWarningCategorySidesHandler) {
        clearInterval(self.runWarningCategorySidesHandler);
        self.runWarningCategorySidesHandler = null;
      }
    },
    getDataOfEachModel() {
      let self = this;
      self.getStatistic(); // 统计数值
      self.getWarningCategories(); // 农情风险多维度AI预警（气象、收割进度、收割热力）
      self.getDriverDispatches(); // 「AI智能机手调度」
      self.getSeasonProgress(); // 全县三夏三秋机收完成进度
      self.getHarvestingProgress(); // 三夏三秋收割热力情况
    },
    loadStatisticIcons() {
      const self = this;
      const imagesContext = require.context(
        "./images/vehicleCode",
        false,
        /\.png$/
      );
      const images = imagesContext.keys().map((key) => {
        const name = key
          .split("/")
          .pop()
          .replace(/\.\w+$/, ""); // 取文件名，去掉扩展名
        const src = imagesContext(key);
        return { name, src };
      });
      self.statisticIcons = images;
      console.log(
        "%c三个统计值的N个图标",
        "color:#C0C",
        JSON.parse(JSON.stringify(images))
      );
    },
  },
  created() {
    let self = this;
    self.loadStatisticIcons();
  },
  mounted() {
    let self = this;
    self.runWeatherCategorySides(); // 左上角「农情风险多维度AI预警」的定时切换
  },
  beforeDestroy() {
    let self = this;
    self.stopWeatherCategorySides();
  },
  directives: {
    // 「AI智能机手调度」
    autoside: {
      inserted: function (el) {
        const interval = INTERVAL.AI智能机手调度.value;
        const container = el;
        let scrollInterval = null;
        let currentIndex = 0;
        function autoScroll() {
          const content = el.querySelector(".siders");
          if (!content) return;
          const items = content.querySelectorAll(".side");
          if (items.length < INTERVAL.AI智能机手调度.min) return;
          const itemWidth =
            items[0].offsetWidth +
            parseInt(window.getComputedStyle(items[0]).marginRight);
          currentIndex = (currentIndex + 1) % items.length;
          let scrollLeft = currentIndex * itemWidth;
          // content.scrollLeft = scrollLeft;
          content.style.transform = `translateX(-${scrollLeft}px)`;
          // console.log('currentIndex', { currentIndex, scrollLeft, itemWidth });
        }
        container.addEventListener("mouseenter", () => {
          if (scrollInterval) {
            clearInterval(scrollInterval);
            scrollInterval = null;
          }
        });
        container.addEventListener("mouseleave", () => {
          if (!scrollInterval) {
            scrollInterval = setInterval(autoScroll, interval);
          }
        });
        scrollInterval = setInterval(autoScroll, interval);
      },
      unbind: function (el) {
        // 组件销毁时清除定时器
        const container = el;
        if (container.scrollInterval) {
          clearInterval(container.scrollInterval);
          container.scrollInterval = null;
        }
      },
    },
    // 「季度收割热力情况」
    vscroll: {
      inserted(el, binding, vnode, oldVnode) {
        console.log("%cv-scroll inserted (季度收割热力情况)", "color:#CC0", {
          el,
          binding,
          vnode,
          oldVnode,
        });
        const interval = INTERVAL.季度收割热力情况.value;
        const container = el.querySelector("table");
        const tbody = el.querySelector("tbody");
        const gaps = window
          .getComputedStyle(container)
          .getPropertyValue("border-spacing")
          .split(/\s+/);
        const gap = parseFloat((gaps.length == 2 && gaps[1]) || gaps[0] || 0);
        let timer = null;
        let scrollTopCurrent = 0;
        function scroll() {
          let scrollable = false;
          const rows = tbody.querySelectorAll("tr");
          const rowHeight = rows[0].offsetHeight;
          if (rows.length >= INTERVAL.季度收割热力情况.min) {
            scrollable = true;
          }
          const visualHeight =
            (rowHeight + gap) * INTERVAL.季度收割热力情况.min; // 一屏可以显示9个，超过这个数量后可以滚动
          const scrollTopMax = (rowHeight + gap) * rows.length - visualHeight;
          // console.log('季度收割热力情况.滚动', { scrollable, rows, min: INTERVAL.季度收割热力情况.min });
          if (!scrollable) return;
          scrollTopCurrent += rowHeight + gap;
          if (scrollTopCurrent > scrollTopMax) {
            scrollTopCurrent = 0;
          }
          container.style.transform = `translateY(-${scrollTopCurrent}px)`;
        }
        function stop() {
          if (timer) {
            clearInterval(timer);
            timer = null;
          }
        }
        function start() {
          console.log("季度收割热力情况.开始滚动");
          if (!timer) {
            timer = setInterval(scroll, interval);
          }
        }
        el.addEventListener("mouseenter", stop);
        el.addEventListener("mouseleave", start);
        start();
        el._vscrollTimer = timer;
      },
      unbind(el) {
        console.log("%cv-scroll unbind (季度收割热力情况)", "color:#C00");
        if (el._vscrollTimer) {
          clearInterval(el._vscrollTimer);
          el._vscrollTimer = null;
        }
      },
    },
    // 上下滚动指令，用于「AI智能机手调度/AI回复」
    scroll: {
      inserted(el) {
        const content = el;
        let scrollInterval = null;
        let isScrolling = true;
        let scrollStep = 1; // 每次滚动的像素
        let scrollDelay = 50; // 滚动间隔时间(ms)
        const needScroll = () => {
          return content.scrollHeight > content.clientHeight;
        };
        const scroll = () => {
          if (!isScrolling) return;
          if (
            content.scrollTop >=
            content.scrollHeight - content.clientHeight
          ) {
            isScrolling = false;
            setTimeout(() => {
              content.scrollTop = 0;
              setTimeout(() => {
                isScrolling = true;
              }, 1000);
            }, 500);
          } else {
            content.scrollTop += scrollStep;
          }
        };
        const startScroll = () => {
          if (!needScroll()) return;
          if (!scrollInterval) {
            scrollInterval = setInterval(scroll, scrollDelay);
          }
        };
        const stopScroll = () => {
          if (scrollInterval) {
            clearInterval(scrollInterval);
            scrollInterval = null;
          }
        };
        content.addEventListener("mouseenter", () => {
          isScrolling = false;
        });
        content.addEventListener("mouseleave", () => {
          isScrolling = true;
        });
        startScroll();
        el._scrollCleanup = () => {
          stopScroll();
          content.removeEventListener("mouseenter", () => {});
          content.removeEventListener("mouseleave", () => {});
        };
      },
      unbind(el) {
        if (el._scrollCleanup) {
          el._scrollCleanup();
        }
      },
    },
  },
  filters: {
    // 米转为公里
    distance(value) {
      if (value == null) {
        return "--";
      }
      const v = parseFloat(value);
      if (isNaN(v)) {
        return "--";
      }
      return (v / 1000).toFixed(1);
    },
  },
};
</script>

<style scoped lang="scss">
@function vw($px) {
  @return ($px / 1920) * 100vw;
}

@function vh($px) {
  @return ($px / 1080) * 100vh;
}

@function fontSize($px) {
  @return 100vw * $px / 1920;
}

@mixin linearText(
  $from: #ffffff,
  $to: #5fde8c,
  $fromOffset: 0%,
  $toOffset: 100%
) {
  color: $from;
  background: linear-gradient(to bottom, $from $fromOffset, $to $toOffset);
  background-clip: text;
  -webkit-text-fill-color: transparent;
}

@mixin line($count: 1) {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: $count;
  overflow: hidden;
  text-overflow: ellipsis;
  word-wrap: break-word;
  hyphens: auto;
}

%scrollbar {
  overflow: auto;

  &::-webkit-scrollbar {
    width: vh(6);
    height: vh(6);
  }

  &::-webkit-scrollbar-track {
    // background: rgba(10, 77, 19, 0.2);
    background: transparent;
    border-radius: vh(2);
  }

  &::-webkit-scrollbar-thumb {
    background: #00af6f;
    border-radius: vh(20);
  }

  &::-webkit-scrollbar-thumb:hover {
    background: rgba(48, 234, 168, 0.8);
  }

  &::-webkit-scrollbar-corner {
    background: rgba(48, 234, 168, 0.6);
  }
}

.page_panel {
  width: 100%;
  height: vh(920);
  display: flex;
  margin-top: -6vh;
  position: relative;
  color: #fff;
  .vehicle-models-selecter {
    position: fixed;
    z-index: 100;
    left: vw(382);
    top: vh(102);
  }
  .map_container {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    width: 100%;
    height: calc(100% + vh(50));
  }

  .left_panel,
  .right_panel {
    width: vw(390);
    z-index: 100;
    padding-left: vw(24);
    display: flex;
    flex-direction: column;
    position: relative;

    .l_top,
    .r_top {
      height: vh(140);
      display: flex;
      padding-bottom: vh(16);
      flex-shrink: 0;

      .l_t_item,
      .r_t_item {
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        position: relative;
        left: vw(8);
        padding-top: vh(16);
        &.disabled {
          cursor: not-allowed;
        }
        &:last-child {
          left: vw(14);
        }

        &_icon {
          width: vw(56);
          height: vh(42);
        }

        &_title {
          font-size: fontSize(14);
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #ffffff;
          text-align: center;
          white-space: nowrap;
          height: vh(34);
          display: flex;
          align-items: center;
          justify-content: center;
        }

        &_num {
          font-size: fontSize(22);
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #0dffa9;
          padding-top: vh(0.5);
        }
      }
    }
  }

  .left_panel {
    left: 0;
    transition: all 300ms;
    &.collected {
      left: -100%;
    }

    .l_center {
      height: vh(315);
      flex-shrink: 0;
      flex-grow: 0;
      box-sizing: border-box;
      padding-bottom: vh(10);

      ul.categories {
        user-select: none;
        list-style: none;
        padding: 0;
        margin: vh(-8) 0 0;
        display: flex;

        li {
          flex: 1;
          text-align: center;
          cursor: pointer;

          &:nth-child(1) .icon {
            background-image: url(./images/icon_qx.png);
            background-size: contain;
          }

          &:nth-child(2) .icon {
            background-image: url(./images/icon_sgjd.png);
            background-size: contain;
          }

          &:nth-child(3) .icon {
            background-image: url(./images/icon_sgrl.png);
            background-size: contain;
          }
          &.disabled {
            cursor: not-allowed;
            .value {
              opacity: 0.5;
            }
          }
          &.selected,
          &:not(.disabled):hover {
            .label {
              opacity: 1;
            }

            .value {
              color: #ffbc24;
            }

            &:nth-child(1) {
              .icon {
                background-image: url(./images/icon_qx_c.png);
              }
            }

            &:nth-child(2) {
              .icon {
                background-image: url(./images/icon_sgjd_c.png);
              }
            }

            &:nth-child(3) {
              .icon {
                background-image: url(./images/icon_sgrl_c.png);
              }
            }
          }
          &:active {
            .label {
              transform: translate(1px, 1px);
            }
          }

          .icon {
            width: vw(61);
            height: vh(52);
            margin: 0 auto;
            background-repeat: no-repeat;
            background-position: center;
          }

          .label {
            font-size: fontSize(14);
            opacity: 0.6;
          }

          .value {
            font-size: fontSize(20);
            font-family: Rajdhani;
            font-weight: bold;
            font-style: italic;
          }
        }
      }

      .tip {
        font-size: fontSize(14);
        color: #62d9ad;
        margin: vh(5) 0;
        padding: vh(5) 0;
      }

      ul.warnings {
        @extend %scrollbar;
        user-select: none;
        list-style: none;
        margin: vh(5) vw(20) 0 0;
        padding: 0 vw(2) 0 0;
        height: vh(160);
        overflow: hidden;
        &.is-weather {
          height: vh(124);
        }
        &:not(.no-scrollable):hover {
          overflow: auto;
          margin-right: vw(14);
        }

        li {
          padding: vh(8);
          background: #0fffab26;
          display: flex;
          cursor: pointer;
          &.empty {
            cursor: default;
            pointer-events: none;
          }
          &:not(.empty):hover {
            background: #0fffab4d;
          }
          &:not(.empty):active {
            transform: translate(1px, 1px);
          }

          & + li {
            margin-top: vh(8);
          }

          &.empty {
            align-items: center;
            justify-content: center;
            color: rgba(255, 255, 255, 0.7);
            pointer-events: none;
          }

          .icon {
            width: vw(56);
            height: vh(42);
            margin-right: vw(10);
            img {
              display: block;
              height: 100%;
              margin: 0 auto;
            }
          }

          .title {
            @include line(2);
            font-size: 1px;
            font-size: fontSize(14);
            line-height: vh(21);
          }
        }
      }
    }

    .l_bottom {
      flex: 1;
      padding-right: vw(40);
      display: flex;
      flex-direction: column;
      font-size: fontSize(14);
      .nothing {
        flex: 1;
        font-size: fontSize(120);
        display: flex;
        justify-content: center;
        align-items: center;
        color: hsla(158, 61%, 62%, 0.1);
        background-color: rgba(13, 255, 169, 0.05);
        border-radius: 3px;
      }

      .box {
        width: 100%;
        overflow: hidden;

        .siders {
          display: flex;
          transition: all 300ms;

          .side {
            width: 100%;
            flex-shrink: 0;
            margin-right: vw(10);
          }
        }
      }

      .question {
        background: url(./images/bg_zx_con_py.png);
        background-size: 100% 100%;
        padding: vh(8);
        height: vh(146);
        box-sizing: border-box;
        font-size: fontSize(14);

        .card {
          display: flex;
          margin-bottom: vh(5);

          .icon {
            position: relative;
            width: vh(64);
            height: vh(64);
            margin-right: vw(8);

            &::before {
              content: "";
              display: block;
              background: linear-gradient(
                90deg,
                rgba(2, 79, 48, 0.8) 0%,
                rgba(2, 79, 48, 0.3) 100%
              );
              position: absolute;
              left: 0;
              top: 0;
              width: 100%;
              height: vh(20);
            }

            &::after {
              content: attr(data-category);
              @include linearText();
              font-weight: bold;
              font-size: fontSize(14);
              font-style: italic;
              // color: #ffffff;
              // background: linear-gradient(0deg, #5fde8c, #ffffff);
              // background-clip: text;
              // -webkit-text-fill-color: transparent;
              display: block;
              text-align: center;
              width: 100%;
              position: absolute;
              left: 0;
              top: 0;
            }

            img {
              display: block;
              width: 100%;
              height: 100%;
            }
          }

          .attr {
            flex: 1;

            .title {
              display: flex;
              align-items: center;

              .name {
                // @mixin linearText($from: #ffffff, $to: #5fde8c, $fromOffset: 0%, $toOffset: 100%) {
                @include linearText(#ffffff, #bdffcc, 35%, 100%);
                font-size: fontSize(16);
                font-weight: bold;
                font-style: italic;
                padding-right: vw(5);
                line-height: 1;
              }

              .tag {
                background: #11913e;
                color: #fff;
                padding: 0 vw(5);
                margin-left: vw(7);
                transform: skewX(-20deg);
                border-radius: vw(2);
                line-height: 1;
                height: 1.2em;
                font-size: fontSize(12);
                font-weight: bold;
              }
            }

            .date {
              @include line(1);
              display: flex;
              font-size: fontSize(14);
              padding: vh(5) 0;

              &::before {
                content: "时间：";
                color: #50a66e;
              }
            }

            .contact {
              // @include line(1);
              display: flex;
              font-size: fontSize(14);
              line-height: 1;

              span {
                display: inline-block;
                vertical-align: middle;
              }

              .user {
                &::before {
                  content: "";
                  display: inline-block;
                  width: 1em;
                  height: 1em;
                  background: url(./images/icon_rw.png) left center no-repeat;
                  margin-right: 0.5em;
                  vertical-align: middle;
                }
              }

              .phone {
                margin-left: vw(20);

                &::before {
                  content: "";
                  display: inline-block;
                  width: 1em;
                  height: 1em;
                  background: url(./images/icon_phone.png) left center no-repeat;
                  vertical-align: middle;
                  margin-right: 0.5em;
                }
              }
            }
          }
        }

        .address {
          @include line(2);

          &:before {
            content: "地点：";
            color: #50a66e;
          }
        }

        .reason {
          @include line(1);
          margin-top: vh(5);

          &:before {
            content: "描述：";
            color: #50a66e;
          }
        }
      }

      .answer {
        background: url(./images/bg_AIhf_con_py.png);
        background-size: 100% 100%;
        padding: vh(8);
        min-height: vh(92);
        box-sizing: border-box;
        font-size: fontSize(14);

        .title {
          // @mixin linearText($from: #ffffff, $to: #5fde8c, $fromOffset: 0%, $toOffset: 100%) {
          @include linearText(#ffffff, #5fde8c, 30%, 89%);
          font-family: YouSheBiaoTiHei;
          font-size: fontSize(18);
          font-style: italic;
          line-height: 1;
          margin-bottom: vh(5);
        }

        .content {
          // @include line(3);
          font-size: fontSize(14);
          height: vh(76);
          overflow: auto;
          @extend %scrollbar;
        }
      }

      ul.recommends {
        @extend %scrollbar;
        list-style: none;
        padding: 0;
        margin: vh(8) 0 0;
        height: vh(155);

        // 以下注释行可以：hover 进再显示滚动条
        // overflow: hidden;
        // border-right: vw(6) solid #073321;
        // &:hover {
        //   overflow: auto;
        //   border-right: none;
        // }
        li {
          background: hsla(156, 80%, 16%, 0.6);
          padding: vh(5) vw(9) vh(7);

          + li {
            margin-top: vh(8);
          }

          &.empty {
            text-align: center;
            color: rgba(255, 255, 255, 0.7);
            pointer-events: none;
          }

          &:hover .user .phone::after {
            content: attr(data-phone);
          }

          &.cooperative {
          }

          &.driver {
            .company {
              display: none;
            }
          }

          .company {
            @include line(1);
            // @mixin linearText($from: #ffffff, $to: #5fde8c, $fromOffset: 0%, $toOffset: 100%) {
            @include linearText(#ffffff, #5fde8c, 35%, 100%);
            font-size: fontSize(16);
            line-height: 1;
            font-weight: bold;
            margin: vh(2) 0 vh(8);
          }

          .user {
            display: flex;
            margin: vh(3) 0;
            align-items: center;

            .name {
              display: inline-block;
              &::before {
                content: "";
                display: inline-block;
                width: 1.1em;
                height: 1em;
                background: url(./images/icon_rw_b.png) left center no-repeat;
                background-size: 100% 100%;
                margin-right: vw(4);
                vertical-align: middle;
                line-height: 1;
                position: relative;
                top: vh(-1);
              }

              span {
                display: inline-block;
                // vertical-align: middle;
                line-height: 1;
              }
            }

            .phone {
              margin-left: vw(8);
              background-color: #11913e;
              padding: 0 0.5em;
              display: inline-block;
              border-radius: 15px;

              &::after {
                content: attr(data-faker);
              }
            }
          }

          .attrs {
            .item-group {
              display: flex;

              // justify-content: space-between;
              .item + .item {
                margin-left: 1em;
              }
            }

            .item {
              @include line(1);
              margin: vh(3) 0;
              &.no-wrap {
                white-space: nowrap;
                flex-shrink: 0;
              }

              &::before {
                content: attr(data-label) "：";
                color: #50a66e;
                width: 3em;
              }

              &::after {
                content: attr(data-unit);
              }

              &.address {
                @include line(2);
              }

              .tail {
                color: #7cffaa;

                &::before {
                  content: "(";
                }

                &::after {
                  content: ")";
                }
              }
            }
          }
        }
      }
    }
  }

  .right_panel {
    padding-left: vw(0);
    padding-right: vw(24);
    position: absolute;
    right: 0;
    height: 100%;
    transition: all 300ms;
    &.collected {
      right: -100%;
    }

    .r_center {
      flex: 1;
      padding-left: vw(10);
      padding-bottom: vh(20);
    }

    .r_bottom {
      height: vh(435);
      overflow: hidden;
      display: flex;
      flex-direction: column;
      padding-left: vw(40);

      .siders {
        overflow: hidden;
        margin-top: vh(5);

        table {
          transition: all 0.5s;
          border-collapse: separate;
          border-spacing: 0 vh(5);
        }
      }

      table {
        margin-top: vh(-5);
        width: 100%;
        table-layout: fixed;

        thead {
          background: hsla(141, 59%, 24%, 0.5);
          border: 1px solid #68b18180;

          th {
            text-align: center;
            padding: vh(5) vw(5);
            color: #7ad299;
          }
        }

        tbody {
          transition: all 0.5s;

          tr {
            margin-top: vh(7);
            background: hsla(146, 47%, 22%, 0.4);

            &.even {
              background: rgba(13, 255, 170, 0.15);
            }

            &.empty {
              td {
                color: rgba(255, 255, 255, 0.7);
                div {
                  height: vh(300);
                  user-select: none;
                  line-height: 1;
                  font-size: fontSize(120);
                  font-weight: 400;
                  color: #62d9ad;
                  opacity: 0.1;
                  background-color: rgba(13, 255, 169, 0.05);
                  display: flex;
                  justify-content: center;
                  align-items: center;
                }
              }
            }

            td {
              height: vh(30);
              text-align: center;
              padding: vh(5) vw(5);
              &:first-child {
                white-space: nowrap;
              }
            }
          }
        }
      }
    }
  }
}
.sideControl {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  .item {
    pointer-events: all;
    width: vw(28);
    height: vh(99);
    // background-color: #c00;
    position: absolute;
    z-index: 1;
    top: vh(425);
    cursor: pointer;
    background: url(./images/collect.png) no-repeat center center;
    background-size: 100% 100%;
    transition: left 200ms, right 200ms;
    opacity: 0;
    &.left {
      transform: rotate(4deg);
      left: vw(411);
      &.collected {
        left: 0;
        transform: rotate(0deg);
        opacity: 1;
      }
    }
    &.right {
      right: vw(411);
      transform: rotate(-184deg);
      &.collected {
        right: 0;
        transform: rotate(180deg);
        opacity: 1;
      }
    }
  }
}
</style>
